<template>
    <svg
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="60"
        height="60">
        <path
            d="M20.6339 17.0321L20.7217 16.9042V16.7491L20.7217 12.1997C20.7217 10.9849 21.7066 10 22.9215 10C24.1364 10 25.1212 10.9849 25.1212 12.1997V15.0864V15.5864H25.6212H28.2329H28.545L28.6821 15.3061C28.8346 14.9944 29.154 14.7814 29.5222 14.7814H30.0004C30.3686 14.7814 30.6881 14.9944 30.8405 15.3061L30.9776 15.5864H31.2897H36.6176C38.454 15.5864 39.9427 17.0751 39.9427 18.9115V46.6745C39.9427 48.5109 38.454 49.9997 36.6176 49.9997H23.3774C21.541 49.9997 20.0523 48.5109 20.0523 46.6745V18.9115C20.0523 18.2132 20.267 17.5666 20.6339 17.0321Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M20.0573 18.9118C20.0573 17.0754 21.546 15.5867 23.3824 15.5867H36.6226C38.459 15.5867 39.9478 17.0754 39.9478 18.9118V46.6748C39.9478 48.5112 38.459 50 36.6226 50H23.3824C21.546 50 20.0573 48.5112 20.0573 46.6748V18.9118Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M25.1373 18.7142C23.5408 18.7142 22.2466 20.0084 22.2466 21.6049V29.2086C22.2466 30.8051 23.5408 32.0993 25.1373 32.0993H34.8764C36.4729 32.0993 37.7671 30.8051 37.7671 29.2086V21.6049C37.7671 20.0084 36.4729 18.7142 34.8764 18.7142H25.1373Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M26.2383 24.0036C26.2383 23.4876 26.6567 23.0692 27.1727 23.0692H32.7942C33.3102 23.0692 33.7286 23.4876 33.7286 24.0036V26.9439C33.7286 27.46 33.3102 27.8783 32.7942 27.8783H27.1728C26.6567 27.8783 26.2383 27.46 26.2383 26.9439V24.0036Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M23.9368 34.986C22.8953 34.986 22.0509 35.8304 22.0509 36.8719C22.0509 37.9135 22.8953 38.7579 23.9368 38.7579C24.9784 38.7579 25.8227 37.9135 25.8227 36.8719C25.8227 35.8304 24.9784 34.986 23.9368 34.986Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M36.4098 34.986C35.3682 34.986 34.5239 35.8304 34.5239 36.8719C34.5239 37.9135 35.3682 38.7579 36.4098 38.7579C37.4514 38.7579 38.2957 37.9135 38.2957 36.8719C38.2957 35.8304 37.4514 34.986 36.4098 34.986Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M31.621 35.0984L31.7918 35.5683L31.621 35.0984C31.4269 35.1689 31.2102 35.2724 31.0253 35.3606C30.9389 35.4018 30.8595 35.4397 30.7925 35.4694C30.5445 35.5795 30.3521 35.6382 30.1733 35.6382C29.9946 35.6382 29.8021 35.5795 29.5541 35.4694C29.4871 35.4397 29.4077 35.4018 29.3214 35.3606C29.1364 35.2723 28.9197 35.1689 28.7256 35.0983C28.5254 35.0255 28.3099 34.986 28.0863 34.986C27.0464 34.986 26.2085 35.8331 26.2085 36.8719C26.2085 37.9107 27.0464 38.7578 28.0863 38.7578C28.2741 38.7578 28.4564 38.7299 28.6287 38.6777C28.8619 38.6071 29.1058 38.4989 29.3116 38.4075C29.3842 38.3753 29.452 38.3452 29.5129 38.3195C29.7773 38.2084 29.9819 38.1464 30.1732 38.1464C30.3644 38.1464 30.5691 38.2084 30.8335 38.3196C30.8945 38.3452 30.9622 38.3753 31.0348 38.4075C31.2406 38.4989 31.4845 38.6072 31.7178 38.6778C31.8901 38.73 32.0724 38.7579 32.2602 38.7579C33.3001 38.7579 34.138 37.9108 34.138 36.872C34.138 35.8332 33.3001 34.9861 32.2602 34.9861C32.0366 34.9861 31.8211 35.0256 31.621 35.0984Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
        <path
            d="M34.7812 16.1719C34.5365 16.1719 34.3369 15.9793 34.3255 15.7375H35.237C35.2256 15.9793 35.0259 16.1719 34.7812 16.1719Z"
            fill="white"
            fill-opacity="0.05"
            stroke="#EEEEEE" />
    </svg>
</template>

<script setup lang="ts"></script>
